import { Divider, List, Paper, Stack } from '@mui/material';

const SidebarBottomGroup = ({ children, onClose }) => {
  return (
    <Stack
      component={Paper}
      elevation={16}
      spacing={1}
      sx={{
        boxShadow: 'none',
        backgroundColor: 'transparent',
        backgroundImage: 'none',
        color: 'common.white',
      }}
    >
      <Divider />
      <List
        component="div"
        disablePadding
        dense
        data-testid="SidebarGroup.List"
        sx={{
          '> :not(:last-child)': {
            mb: 0.5,
          },
        }}
      >
        {children.map((node, i) => (
          <node.component
            {...node}
            key={`${node.title}${i}`}
            onClose={onClose}
          />
        ))}
      </List>
    </Stack>
  );
};

export default SidebarBottomGroup;
